module.exports = __webpack_public_path__ + "img/faq.b8bbdc4c.png";